import * as React from "react";
import { forwardRef } from "react";
const SvgBoardArrowRight = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "Iconsax/Linear/arrowdown2" }, /* @__PURE__ */ React.createElement("path", { id: "Vector", d: "M6.7124 3.05994L11.6024 7.94994C12.1799 8.52744 12.1799 9.47244 11.6024 10.0499L6.7124 14.9399", stroke: "var(--stroke)", strokeWidth: 1.5, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" })));
const ForwardRef = forwardRef(SvgBoardArrowRight);
export default ForwardRef;
